export default __webpack_public_path__ + "static/media/te4.66c9c8de.png";